"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WallboxInstallPriorityForJob = void 0;
const typeorm_1 = require("typeorm/browser");
const job_1 = require("./job");
let WallboxInstallPriorityForJob = class WallboxInstallPriorityForJob {
};
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Date)
], WallboxInstallPriorityForJob.prototype, "carDelivery", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], WallboxInstallPriorityForJob.prototype, "carType", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], WallboxInstallPriorityForJob.prototype, "chargingOpportunity", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], WallboxInstallPriorityForJob.prototype, "urgentReasons", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], WallboxInstallPriorityForJob.prototype, "urgentReason", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Array)
], WallboxInstallPriorityForJob.prototype, "kfwFunding", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], WallboxInstallPriorityForJob.prototype, "score", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], WallboxInstallPriorityForJob.prototype, "jobApiId", void 0);
__decorate([
    (0, typeorm_1.OneToOne)(() => job_1.Job),
    (0, typeorm_1.JoinColumn)({ name: 'job_api_id', referencedColumnName: 'apiId' }),
    __metadata("design:type", job_1.Job)
], WallboxInstallPriorityForJob.prototype, "job", void 0);
WallboxInstallPriorityForJob = __decorate([
    (0, typeorm_1.ViewEntity)({
        expression: `
    SELECT 
        jp.properties->'car_delivery' car_delivery,
        jp.properties->'car_type' car_type,
        jp.properties->'charging_opportunity' charging_opportunity,
        jp.properties->'urgent_reasons' urgent_reasons,
        jp.properties->'urgent_reason' urgent_reason,
        jp.properties->'kfw_funding' kfw_funding,
        jp.job_api_id job_api_id,
        CASE
          WHEN jp.properties -> 'car_delivery' ISNULL OR jp.properties -> 'car_delivery' = 'null' THEN NULL::double precision
          WHEN ROUND(
              EXTRACT(
                  'day'
                  FROM (
                          NOW() - (jp.properties->'car_delivery')::text::date::timestamp
                      )
              ) / 30
          ) * 10 + (
              CASE
                  WHEN jp.properties->'car_type' ? 'Hybrid-Auto' THEN 20
                  WHEN jp.properties->'car_type' ? 'Voll elektrisches Auto' THEN 100
                  ELSE 0
              END
          ) + (
              CASE
                  WHEN jp.properties->'charging_opportunity' ? 'Ja' THEN 50
                  WHEN jp.properties->'charging_opportunity' ? 'Nein' THEN 100
                  ELSE 0
              END
          ) + (
              CASE
                  WHEN jp.properties->'urgent_reasons' ? 'Ja' THEN 300
                  ELSE 0
              END
          ) = 0THEN NULL
          ELSE ROUND(
              EXTRACT(
                  'day'
                  FROM (
                          NOW() - (jp.properties->'car_delivery')::text::date::timestamp
                      )
              ) / 30
          ) * 10 + (
              CASE
                  WHEN jp.properties->'car_type' ? 'Hybrid-Auto' THEN 20
                  WHEN jp.properties->'car_type' ? 'Voll elektrisches Auto' THEN 100
                  ELSE 0
              END
          ) + (
              CASE
                  WHEN jp.properties->'charging_opportunity' ? 'Ja' THEN 50
                  WHEN jp.properties->'charging_opportunity' ? 'Nein' THEN 100
                  ELSE 0
              END
          ) + (
              CASE
                  WHEN jp.properties->'urgent_reasons' ? 'Ja' THEN 300
                  ELSE 0
              END
          )
      END score
      FROM public.job_properties jp
    `,
        name: 'wallbox_install_priority_for_job',
        schema: 'public',
    })
], WallboxInstallPriorityForJob);
exports.WallboxInstallPriorityForJob = WallboxInstallPriorityForJob;
//# sourceMappingURL=wallbox-install-priority-for-job.js.map